import { useWizardStore } from "@/stores/wizard-store";
import { usePermission } from "@/lib/permissions/usePermission";

/**
 * Read-only when EITHER signal says so:
 * - the API's own `editable` flag (false for an approved version, or a non-owner without the `.all` scope)
 * - this staff member holds neither edit permission at all — belt-and-suspenders for the API's owner
 *   exemption, which only checks "not the owner", not whether the owner actually has edit rights. A
 *   viewer-role account that owns a draft it created (e.g. `permissions: ["property.view.own"]`, no
 *   edit.*) comes back `editable: true` from the API for that reason alone — this catches it anyway.
 */
export function useIsWizardReadOnly(): boolean {
  const editable = useWizardStore((s) => s.editable);
  const canEditAll = usePermission("property.edit.all");
  const canEditOwn = usePermission("property.edit.own");
  return !editable || !(canEditAll || canEditOwn);
}
